import React from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';

import { OCardCarousel as OCardCarouselComp } from '@marriott/mi-web-ui-kit';
import clsx from 'clsx';

export const OCardCarouselConfig = {
  emptyLabel: 'OCardCarousel',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/o-card-carousel`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OCardCarousel = (props: any) => {
  const model = props.model || {};
  const { styleclass, componentId } = model;

  return (
    <div
      data-testid="o-card-carousel-comp"
      data-component-name="o-card-carousel"
      id={componentId}
      className={clsx(styleclass)}
    >
      <EditableComponent config={OCardCarouselConfig} {...props}>
        <OCardCarouselComp {...props} />
      </EditableComponent>
    </div>
  );
};
